import { useCallback } from "react";
import { RecentlyOpenedItemConfigurationProps, useResolveRecentlyOpenedItemForPersistence } from "./useResolveRecentlyOpenedItemForPersistence";
import { AnalyticsAppEventData } from "client/Api/Analytics/analytics";
import { useAnalyticsStore } from "client/Features/Analytics/analyticsStore";
import { useRecentlyOpenedResults } from "client/Features/Search/RecentSearch/Persistence/useRecentlyOpenedResults";
import { AppType } from "client/Api/Apps/common";
import { GlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/models";
import { getHubUrlForCommunity } from "client/Features/Hub/Communities/CommunitiesPage";
import { HubDataSource } from "client/Api/Hub/hub";
import { navigateTo } from "client_legacy/ndaw/navigator";

export type CommunityPostNavigationHandlerProps = {
	id: number;
}
	& RecentlyOpenedItemConfigurationProps;

export function useCommunityPostNavigationHandler(props: CommunityPostNavigationHandlerProps): (() => void) {
	const {
		id
	} = props;

	const addAnalyticsAppEvent: (data: AnalyticsAppEventData) => void = useAnalyticsStore(x => x.addAppEvent);
	const { registerFromRecentlyOpened: registerRecentlyOpenedItem } = useRecentlyOpenedResults();

	const recentlyOpenedItem: GlobalSearchItemPersistedModel = useResolveRecentlyOpenedItemForPersistence(props);

	return useCallback(
		(): void => {
			addAnalyticsAppEvent({ appType: AppType.Hub });
			registerRecentlyOpenedItem(recentlyOpenedItem);
			navigateToCommunityPost(id);
		},
		[
			addAnalyticsAppEvent,
			id,
			recentlyOpenedItem,
			registerRecentlyOpenedItem
		]
	);
}

export function navigateToCommunityPost(id: number): void {
	const url: string = getHubUrlForCommunity({
		source: HubDataSource.Community,
		postId: id
	});

	navigateTo(url);
}